import { divide } from 'lodash';
import React from 'react';

const Label = ({ value, label, htmlFor, children }) => {
  const isEmpty =
    !value ||
    value === null ||
    value === undefined ||
    value === '' ||
    (Array.isArray(value) && value.length === 0);

  return (
    <div className='relative w-full'>
      {!isEmpty && (
        <div className='absolute  z-10  mb-1 text-[10px] rounded-md shadow-xs pl-2 pr-2  bg-white text-gray-700  font-bold -top-1 left-3  p-[1px]'>
          <label
            style={{ lineHeight: 'normal' }}
            className=' block bg-white  max-w-[150px] whitespace-nowrap overflow-hidden text-ellipsis '
            htmlFor={htmlFor}
            title={label}
          >
            {label}
          </label>
        </div>
      )}
      {children}
    </div>
  );
};

export default Label;
